<template>
  <!-- 运输规划 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button
          v-if="hasPermiss('admin:task:createTask')"
          class="glo_btnItems glo_bgcMainColor"
          @click="transportPlan"
          >新增任务
        </el-button>
        <el-button
          v-if="hasPermiss('admin:task:loadSure')"
          class="glo_btnItems"
          @click="loadSureMore()"
          >批量装货</el-button
        >
        <el-button
          v-if="hasPermiss('admin:task:unloadSure')"
          class="glo_btnItems"
          @click="unloadSureDialog()"
          >批量卸货</el-button
        >
        <el-button
          v-if="hasPermiss('admin:task:delTask')"
          class="glo_btnItems"
          @click="delBtns()"
          >批量删除</el-button
        >

        <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="dc">导出</el-dropdown-item>
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <div ref="queryForm">
      <el-form
        :model="queryData"
        :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'"
        label-position="left"
      >
        <!-- 时间组件 -->
        <el-form-item class="queryItemsTimes">
          <multitime
            :timeType="timeType"
            :timeTypes="timeTypes"
            :startTime="startTime_a"
            :endTime="endTime_a"
            @timestatus="timestatus"
            @queryBtn_ok="queryBtn_time"
          >
          </multitime>
        </el-form-item>
        <el-form-item class="queryItems" label="运单号:">
          <el-input
            placeholder="请输入"
            clearable
            v-model="queryData.waybillNumber"
          ></el-input>
        </el-form-item>
        <el-form-item class="queryItems" label="运输类型:">
          <el-select
            filterable
            clearable
            v-model="queryData.transportType"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in transport_typeList"
              :key="index"
              :label="item.showName"
              :value="item.statusVal"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="queryItems" label="运输计划:">
          <el-select
            filterable
            clearable
            v-model="queryData.transportPlan"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in transport_planList"
              :key="index"
              :label="item.showName"
              :value="item.statusVal"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="queryItems" label="规划状态:">
          <el-select
            filterable
            clearable
            v-model="queryData.taskStatus"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in task_statusList"
              :key="index"
              :label="item.showName"
              :value="item.statusVal"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item class="queryItems" label="客户名称:">
          <el-select
            clearable
            filterable
            remote
            :remote-method="getCustomerList"
            v-model="queryData.customerName"
            placeholder="请选择"
            @change="changeCustomer"
          >
            <el-option
              v-for="(item, index) in CustomerLists"
              :key="index"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="queryItems" label="外发承运商:">
          <el-select
            filterable
            clearable
            v-model="queryData.carrierId"
            placeholder="请输入"
            remote
            :remote-method="getCarrierList"
            @change="changeCarrier"
          >
            <el-option
              v-for="(item, index) in CarrierLists"
              :key="index"
              :label="item.carrierName"
              :value="item.carrierId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="queryItems" label="装货地址:">
          <el-input
            placeholder="请输入"
            clearable
            v-model="queryData.taskStartAllAddress"
          ></el-input>
        </el-form-item>
        <el-form-item class="queryItems" label="卸货地址:">
          <el-input
            placeholder="请输入"
            clearable
            v-model="queryData.taskEndAllAddress"
          ></el-input>
        </el-form-item>
        <el-form-item class="queryItems queryItemsAllQuery" label="全字段查询:">
          <div class="AllQueryItems">
            <el-select
              class="AllQuerySelect"
              filterable
              clearable
              v-model="queryData.fieldName"
              placeholder="请选择"
              @change="changeField"
            >
              <el-option
                v-for="(item, index) in myTableHeardAll"
                :key="index"
                :label="item.name"
                :value="item.field"
              ></el-option>
            </el-select>
            <!-- 是状态类型的 -->
            <el-select
              v-if="isList"
              class="AllQuerySelect"
              filterable
              clearable
              v-model="queryData.fieldVal"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in downList"
                :key="index"
                :label="item.showName"
                :value="item.statusVal"
              ></el-option>
            </el-select>
            <!-- 输入 -->
            <el-input
              v-else
              class="AllQueryInput"
              clearable
              v-model="queryData.fieldVal"
              placeholder="请输入"
              @keyup.enter.native="queryBtn_ok"
            ></el-input>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        >
        </el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <!-- 某个字段需要单独操作  例如点击可以跳转 -->
          <el-table-column
            v-if="item.field == 'huoWu' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div
                class="linkTabel"
                v-if="hasPermiss('admin:task:getWaybillAddrItems')"
                @click.stop="getGoodsNameDetails(scope.row)"
              >
                货物明细
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column
            v-else-if="item.field == 'waybillNumber' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="left"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div
                class="linkTabel"
                @click.stop="$TOOLS.goYdDetails(scope.row)"
              >
                {{ scope.row.waybillNumber }}
              </div>
            </template>
          </el-table-column> -->
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-else-if="item && item.isShow"
          >
          </el-table-column>
        </template>
        <el-table-column fixed="right" label="操作" min-width="180px">
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button
                v-if="hasPermiss('admin:task:loadSure')"
                class="rbtns"
                @click.stop="loadSureMore(scope.row)"
                >装货</el-button
              >
              <el-button
                v-if="hasPermiss('admin:task:unloadSure')"
                class="rbtns"
                @click.stop="unloadSureDialog(scope.row)"
                >卸货</el-button
              >
              <el-button
                v-if="hasPermiss('admin:task:delTask')"
                class="rbtns"
                @click.stop="delBtns(scope.row)"
                >删除</el-button
              >
              <!-- 如果按钮超过4个就要用下面这种下拉的样式 -->
              <!-- <el-dropdown
                class="rbtns"
                @command="handleCommandBtns($event, scope.row)"
              >
                <el-button type="primary">
                  更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">详情</el-dropdown-item>
                  <el-dropdown-item command="b">外发录入</el-dropdown-item>
                  <el-dropdown-item command="c">改运单号</el-dropdown-item>
                  <el-dropdown-item command="d">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
    </paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    >
    </sorttable>

    <!-- 客户跟踪 -->
    <addCustomerTarck
      :showDia1="showDia1"
      :documentNumbers="documentNumbers"
      :documentStatus="documentStatus"
      :isdisabledStatus="true"
      @confirmAdd="confirmAdd"
      @closeDia1="closeDia1"
    ></addCustomerTarck>

    <!-- 弹窗 装货确认-->
    <myDialog
      :diaWidth="diaWidth1"
      :dialogTitle="dialogTitle1"
      :isShowDialog="isShowDialog1"
      @handleCloseDia="handleCloseDia1"
      @diaCancelBtn="handleCloseDia1"
      @diaConfirmBtn="diaConfirmBtn1"
    >
      <div class="glo_dialogForm">
        <el-form
          v-if="isShowDialog1"
          class="diaForm"
          ref="dialogForm1"
          :model="dialogForm1"
          label-width="100px"
          :rules="rulesForm1"
        >
          <!-- <el-form-item class="dialogFormItems" prop="aaa" label="活动名称:">
            <el-input v-model="dialogForm1.aaa"></el-input>
          </el-form-item> -->

          <el-form-item
            class="dislogFormTextarea"
            prop="remarks"
            label="已选任务:"
          >
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm1.taskStr"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item class="dislogFormTextarea" prop="remarks" label="备注:">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm1.remarks"
            ></el-input>
          </el-form-item>
          <el-form-item label="装货图片:">
            <uploadimgs
              @input="changeFileList"
              :fileNameLists="fileNameLists1"
              :limit="6"
            ></uploadimgs>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 卸货确认 -->
    <myDialog
      :diaWidth="diaWidth2"
      :dialogTitle="dialogTitle2"
      :isShowDialog="isShowDialog2"
      @handleCloseDia="handleCloseDia2"
      @diaCancelBtn="handleCloseDia2"
      @diaConfirmBtn="diaConfirmBtn2('dialogFormRef')"
    >
      <div class="glo_dialogForm">
        <el-form
          v-if="isShowDialog2"
          class="diaForm"
          ref="dialogFormRef"
          :model="dialogForm2"
          label-width="100px"
          :rules="rulesForm"
        >
          <el-form-item
            class="dialogFormItems"
            prop="unloadType"
            label="卸货类型:"
          >
            <el-select v-model="dialogForm2.unloadType" placeholder="请选择" filterable>
              <el-option
                v-for="(item, idx) in unloadTypeList"
                :key="idx"
                :label="item.name"
                :value="item.val"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="returnCangReason"
            label="回仓原因:"
            v-if="dialogForm2.unloadType == 'hui_cang:unload_type'"
          >
            <el-select
              v-model="dialogForm2.returnCangReason"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in returnCangReasonList"
                :key="index"
                :label="item.key"
                :value="item.confDictId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="isOutGoing"
            label="是否外发到站:"
            v-if="dialogForm2.unloadType == 'zheng_chang:unload_type'"
          >
            <el-select v-model="dialogForm2.isOutGoing" placeholder="请选择">
              <el-option
                v-for="(item, idx) in isOutGoingList"
                :key="idx"
                :label="item.name"
                :value="item.val + ''"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="returnCangStorageId"
            label="回仓仓库:"
            v-if="dialogForm2.unloadType == 'hui_cang:unload_type'"
          >
            <el-select
              v-model="dialogForm2.returnCangStorageId"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in storageList"
                :key="index"
                :label="item.name"
                :value="item.documentId"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            v-if="dialogForm2.isOutGoing == '0'"
            class="dislogFormTextarea"
            prop="remarks"
            label="备注:"
          >
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm2.remarks"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="dialogForm2.isOutGoing == '1'"
            class="dislogFormTextarea"
            prop="outgoingRemarks"
            label="外发备注:"
          >
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm2.outgoingRemarks"
            ></el-input>
          </el-form-item>
          <el-form-item style="width: 100%" label="卸货图片:">
            <uploadimgs
              @input="changeFileList2"
              :fileNameLists="fileNameLists2"
              :limit="9"
            ></uploadimgs>
          </el-form-item>
          <el-form-item
            style="width: 100%"
            v-if="dialogForm2.isOutGoing == '1'"
            label="外发图片:"
          >
            <uploadimgs
              @input="changeFileList3"
              :fileNameLists="fileNameLists3"
              :limit="9"
            ></uploadimgs>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 弹窗 查看货物明细 -->
    <myDialog
      :diaWidth="diaWidth3"
      :dialogTitle="dialogTitle3"
      :isShowDialog="isShowDialog3"
      @handleCloseDia="handleCloseDia3"
      @diaCancelBtn="handleCloseDia3"
      @diaConfirmBtn="diaConfirmBtn3()"
    >
      <div class="glo_Table" v-if="isShowDialog3">
        <el-table header-align="center" :data="goodsNameData" border stripe>
          <el-table-column
            fixed="left"
            align="center"
            label="序号"
            type="index"
            width="60"
          >
          </el-table-column>
          <el-table-column
            fixed="left"
            align="center"
            type="selection"
            width="60"
          ></el-table-column>
          <template v-for="(item, index) in goodsTableHeard">
            <el-table-column
              :key="index"
              :label="item.name"
              :prop="item.field"
              align="center"
              sortable
              :show-overflow-tooltip="true"
              :min-width="item.width"
              :data-isTotal="item.isTotal"
              v-if="item && item.isShow"
            >
            </el-table-column>
          </template>
        </el-table>
      </div>
    </myDialog>
  </div>
</template>
<script>
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import multitime from "@/components/multiTime.vue";
import myDialog from "@/components/Dialog.vue";
import queryBtns from "@/components/queryBtns.vue";
import addCustomerTarck from "@/components/CustomerServiceTrackingNew.vue";
import uploadimgs from "@/components/upLoadImgs.vue";

export default {
  inject: ["reload"],
  components: {
    sorttable,
    paging,
    multitime,
    addCustomerTarck,
    myDialog,
    uploadimgs,
    queryBtns,
  },
  data() {
    return {
      //  -----  查询  ------
      queryData: {
        carrierId: "",
        customerName: "",
        customerOrderNumber: "",
        endCreateTime: "",
        endTaskCreateTime: "",
        fieldName: "",
        fieldVal: "",
        number: "",
        startCreateTime: "",
        startTaskCreateTime: "",
        taskEndAllAddress: "",
        taskStartAllAddress: "",
        taskStatus: "",
        transportType: "",
        transportPlan: "",
        waybillNumber: "",
      }, //  表单查询数据
      //  时间类型
      timeTypes: [
        {
          value: "0",
          label: "业务时间",
        },
        {
          value: "1",
          label: "创建时间",
        },
      ],
      timeType: "1", //  时间类型
      startTime_a: "",
      endTime_a: "",

      MoreConditions: "更多条件", //  输入框绑定动态class
      isHaseMore: false, //false == 更多条件  true ==收起条件

      //      -------  表格  ----------
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条
      tableHeigth: "75vh", //  表格高度
      selectTableData: [], //  表格选中的数据

      show_sortTableHeard: false, //显示表格设置弹窗
      // 默认表头
      tabelHeadeTitle: [
        {
          name: "任务编号",
          field: "number",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "运单号",
          field: "waybillNumber",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "外发单号",
          field: "outgoingNumber",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: "任务运输方式",
          field: "transportMethodShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "运输类型",
          field: "transportTypeShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "运输计划",
          field: "transportPlanShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货单号",
          field: "takeAddrNumber",
          width: "200",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "状态",
          field: "taskStatusShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "货物",
          field: "huoWu",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户单号",
          field: "customerOrderNumber",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户名称",
          field: "customerName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户编号",
          field: "customerNumber",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "入仓仓库",
          field: "intoStorageName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "外部运输承运商",
          field: "carrierName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "外发承运商",
          field: "outgoingCarrierName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "外发承运商网点",
          field: "outgoingDeptName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货时间",
          field: "takeTime",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "交货日期",
          field: "deliveryTime",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "装货地址",
          field: "taskStartAllAddress",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "卸货地址",
          field: "taskEndAllAddress",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "发车批次号",
          field: "dispatchNumber",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "车牌号",
          field: "carNumber",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "挂车号码",
          field: "trailerNumber",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "司机",
          field: "driverName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "押运员",
          field: "supercargoName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "发车合同号",
          field: "dispatchContractNumber",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "创建人",
          field: "createUserName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "创建时间",
          field: "createTime",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "装货时间",
          field: "loadTime",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "装货操作人",
          field: "loadUserName",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "卸货时间",
          field: "unloadTime",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "卸货操作人",
          field: "unloadUserName",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: "退单状态",
          field: "chargebackStatusShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "退单原因",
          field: "chargebackReason",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "是否回仓",
          field: "returnCangStatusShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "回仓原因",
          field: "returnCangReason",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "回仓仓库",
          field: "returnCangStorageName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货人",
          field: "unloadContacts",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货单位",
          field: "unloadCompany",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "件数",
          field: "packageCout",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "毛重",
          field: "grossWeight",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "净重",
          field: "netWeight",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "体积",
          field: "volume",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      myTableHeard: [], //  我的表头

      originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)
      tableData: [], //  表格数据

      allCheck: false, //  全选
      sortName: "综合查询模板", //  排序名
      selectLength: 0, //  显示的长度

      totalArr: [], //  表格需要合计的字段
      className: "", //  导出需要
      pageGroupName: "TransportationPlann", //  页面标识

      // 新建客服跟踪
      showDia1: false,
      documentNumbers: "",
      documentStatus: "", //包裹单据

      fileNameLists1: [], //上传组件的
      fileNameLists3: [], //外发图片
      fileNameLists2: [], //卸货图片
      // ==== 弹窗组件属性 start ====
      isShowDialog1: false,
      dialogTitle1: "装货确认",
      diaWidth1: "60%",
      dialogForm1: {
        // 弹窗表单数据
        remarks: "",
        taskStr: "",
      },
      rulesForm1: {
        aaa: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      // ==== 弹窗组件属性 end ====
      // ==== 弹窗组件属性 start ====
      isShowDialog2: false,
      dialogTitle2: "卸货确认",
      diaWidth2: "40%",
      dialogForm2: {
        // 弹窗表单数据
        isOutGoing: "0",
        fileIds: [],
        outgoingFileIds: [],
        outgoingRemarks: "",
        remarks: "",
        returnCangReason: "",
        returnCangStorageId: "",
        taskIds: [],
        unloadType: "",
      },
      rulesForm: {
        aaa: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      // ==== 弹窗组件属性 end ====
      // ==== 弹窗组件属性 start ====
      isShowDialog3: false,
      dialogTitle3: "货物信息",
      diaWidth3: "80%",
      dialogForm3: {
        // 弹窗表单数据
        aaa: "",
        bbb: "",
        ccc: "",
      },
      // ==== 弹窗组件属性 end ====

      rules: {
        aaa: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
      },

      transport_typeList: [], //运输类型
      transport_planList: [], //运输计划
      task_statusList: [], //运输规划状态
      chargeback_StatusList: [], //退单状态
      CustomerLists: [], //客户列表
      CarrierLists: [], //承运商列表

      myTableHeardAll: [],
      delArray: [],
      downList: [], //承运商列表
      storageList: [], //仓库列表
      isList: false, //全字段查询选择的是否是下拉列表

      unloadTypeList: [
        {
          name: "正常卸货",
          val: "zheng_chang:unload_type",
        },
        {
          name: "回仓卸货",
          val: "hui_cang:unload_type",
        },
      ],
      isOutGoingList: [
        {
          name: "是",
          val: "1",
        },
        {
          name: "否",
          val: "0",
        },
      ],
      returnCangReasonList: [],
      goodsTableHeard: [
        {
          name: "提货单号",
          field: "takeAddrNumber",
          width: "200",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货省份",
          field: "provinceName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货城市",
          field: "cityName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货区县",
          field: "areaName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货地址",
          field: "address",
          width: "200",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "货物编号",
          field: "goodsNumber",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "货物名称",
          field: "goodsName",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "品类",
          field: "itemCategoryName",
          width: "100",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "包装",
          field: "packageName",
          width: "100",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "件数",
          field: "packageCout",
          width: "80",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "毛重",
          field: "grossWeight",
          width: "80",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "净重",
          field: "netWeight",
          width: "100",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "体积重量",
          field: "volumeWeight",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "计费取值",
          field: "billingWeight",
          width: "130",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "体积/m³",
          field: "volume",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "规格",
          field: "specs",
          width: "100",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      loadSureMoreIds: [],
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.myTableHeard = this.tabelHeadeTitle;
    if (this.originalTabelHeadeTitle.length === 0) {
      this.originalTabelHeadeTitle = JSON.parse(
        JSON.stringify(this.tabelHeadeTitle)
      );
    }
    this.startTime_a = this.$TOOLS.getFlexDate(this.$COMMON.timeNum); //开始时间;
    this.endTime_a = this.$TOOLS.getCurrentDate(); //今天的时间;;

    // 全字段查询的数组 删除显示值
    var myTableHeardAll = JSON.parse(JSON.stringify(this.tabelHeadeTitle));
    //  状态类型数组,要单独处理
    this.delArray = [
      {
        val: "transportMethod",
        valShow: "transportMethodShow",
      },
      {
        val: "transportPlan",
        valShow: "transportPlanShow",
      },
      {
        val: "taskStatus",
        valShow: "taskStatusShow",
      },
      {
        val: "chargebackStatus",
        valShow: "chargebackStatusShow",
      },
      {
        val: "returnCangStatus",
        valShow: "returnCangStatusShow",
      },
    ];
    this.myTableHeardAll = this.$TOOLS.delMorField(
      myTableHeardAll,
      this.delArray
    );

    //获取默认表头
    this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName);
  },
  activated() {
    // 每次进页面都会触发的写这里
    //计算获取表格高度
    this.fetTableHeight();
    this.getData();
  },
  mounted() {
    this.getStatusValList("bill_tms_transport_task_v3.transport_type"); //运输类型
    this.getStatusValList("bill_tms_transport_task_v3.transport_plan"); //运输计划
    this.getStatusValList("bill_tms_transport_task_v3.task_status"); //运输规划状态
    // this.getStatusValList("bill_tms_transport_task_v3.chargeback_Status"); //退单状态
    this.getCustomerList(); //  获取客户列表
    this.getCarrierList(); // 获取承运商列表
  },
  watch: {},
  methods: {
    // 根据字典类型获取字典值下拉列表
    getConfDictValDownList(dictType) {
      this.$API
        .wtl_getConfDictValDownList({ dictType: dictType })
        .then((res) => {
          let arrs = res.data.result || [];
          if (dictType == "return_cang_reason") {
            // 回仓原因
            this.returnCangReasonList = arrs;
          }
        });
    },
    // 选择字段查询
    changeField(e) {
      this.isList = false;
      this.queryData.fieldVal = "";
      this.delArray.forEach((item) => {
        if (item.val == e) {
          this.isList = true;

          if (e == "taskStatus") {
            this.downList = this.task_statusList;
          }
          if (e == "transportPlan") {
            this.downList = this.transport_planList;
          }
          if (e == "transportMethod") {
            this.downList = this.transport_typeList;
          }
          if (e == "chargebackStatus") {
            this.downList = this.chargeback_StatusList;
          }
          if (e == "returnCangStatus") {
            this.downList = [];
          }
        }
      });
    },
    // 获取状态下拉列表
    getStatusValList(val) {
      this.$TOOLS.getStatusValList(val).then((res) => {
        // 运输类型
        if (val === "bill_tms_transport_task_v3.transport_type") {
          this.transport_typeList = res;
        }
        // 运输计划
        if (val === "bill_tms_transport_task_v3.transport_plan") {
          this.transport_planList = res;
        }
        // 运输规划状态
        if (val === "bill_tms_transport_task_v3.task_status") {
          this.task_statusList = res;
        }
        // 退单状态
        if (val === "bill_tms_transport_task_v3.chargeback_status") {
          this.chargeback_StatusList = res;
        }
      });
    },
    // 选择承运商
    changeCarrier(e) {
      if (!e) {
        this.getCarrierList();
      }
      this.queryBtn_ok();
    },
    // 获取承运商列表
    getCarrierList(carrierName) {
      this.$API
        .CarrierList({
          pageStart: 1,
          pageTotal: 200,
          carrierName: carrierName || "",
        })
        .then((res) => {
          this.CarrierLists = res.data.result.data || [];
        });
    },

    // 根据对象类型获取对象的下拉列表
    getObjectUserDownList(type) {
      this.$COMAPI.getObjectUserDownList(type).then((res) => {
        if (type == "storage") {
          //获取网点列表
          this.storageList = res || [];
        }
      });
    },

    // 获取客户列表
    getCustomerList(name) {
      this.$API
        .wtl_getObjectUserDownList({
          key: "customer",
          name: name || "",
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.CustomerLists = res.data.result.data || [];
        });
    },
    // 选择或者清除客户时触发
    changeCustomer(e) {
      if (!e) {
        this.getCustomerList();
      }
      this.queryBtn_ok();
    },
    //  xxx
    chaiDan(a) {},

    // 修改运单
    WaybillEdit() {
      //   this.$router.push("/WaybillManage/WaybillEdit");
    },
    // 修改运单
    transportPlan() {
      this.$router.push({
        path: "/DispatchCar/AddTransportationPlan",
      });
    },

    // 打开卸货弹窗
    unloadSureDialog(row) {
      console.log(row);
      let ids = [];
      if (row) {
        ids.push(row.taskId);
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.warning("请选择需要操作的任务");
          return false;
        }
        this.selectTableData.forEach((item) => {
          ids.push(item.taskId);
        });
      }

      this.dialogForm2.taskIds = ids;

      this.isShowDialog2 = true;
      this.getObjectUserDownList("storage"); //获取网点列表
      this.getConfDictValDownList("return_cang_reason"); //回仓原因
    },

    // 查看货物明细:
    getGoodsNameDetails(row) {
      this.$API.wtl_getTaskItems({ taskId: row.taskId }).then((res) => {
        this.goodsNameData = res.data.result || [];
        this.isShowDialog3 = true;
      });
    },

    // 删除
    delBtns(row) {
      let ids = [];
      if (row) {
        ids.push(row.taskId);
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.warning("请选择需要操作的任务");
          return false;
        }
        this.selectTableData.forEach((item) => {
          ids.push(item.taskId);
        });
      }

      this.$confirm("是否对所选任务进行删除操作?请谨慎操作", "提示:")
        .then(() => {
          this.$API.wtl_delTask({ taskIds: ids }).then((res) => {
            this.$message.success(res.data.message || "操作成功");
            this.getData();
          });
        })
        .catch(() => {});
    },

    // 选择图片
    changeFileList(array) {
      this.fileNameLists1 = array;
    },
    // 选择图片
    changeFileList2(array) {
      this.fileNameLists2 = array;
    },
    // 选择图片
    changeFileList3(array) {
      this.fileNameLists3 = array;
    },
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)

    // 装货
    loadSureMore(row) {
      let ids = [];
      let str = "";
      if (row) {
        ids.push(row.taskId);
        str = row.number;
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.warning("请选择需要操作的任务");
          return false;
        }
        this.selectTableData.forEach((item) => {
          ids.push(item.taskId);
          str += item.number + " , ";
        });
      }
      this.loadSureMoreIds = ids;
      this.dialogForm1.taskStr = str;

      this.isShowDialog1 = true;
    },

    handleCloseDia1() {
      this.isShowDialog1 = false;
      this.fileNameLists1 = [];

      this.dialogForm1 = {
        remarks: "",
        taskStr: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn1() {
      console.log(this.fileNameLists1);
      let fileIds = this.fileNameLists1.map((item) => {
        return item.name;
      });
      this.$API
        .wtl_loadSure({
          taskIds: this.loadSureMoreIds,
          fileIds: fileIds || [],
          remarks: this.dialogForm1.remarks || "",
        })
        .then((res) => {
          this.$message.success(res.data.message || "操作成功");
          this.getData();
          this.isShowDialog1 = false;
        });
    },

    /***
     * ====== 弹窗组件方法 ======
     */
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia2() {
      this.isShowDialog2 = false;
      this.dialogForm2 = {
        isOutGoing: "0",
        fileIds: [],
        outgoingFileIds: [],
        outgoingRemarks: "",
        remarks: "",
        returnCangReason: "",
        returnCangStorageId: "",
        taskIds: [],
        unloadType: "",
      };
      this.fileNameLists2 = [];
      this.fileNameLists3 = [];
    },
    //  弹窗确认保存事件
    diaConfirmBtn2(formName) {
      let param = JSON.parse(JSON.stringify(this.dialogForm2));

      let arr1 = this.fileNameLists2.map((item) => {
        return item.name;
      });
      let arr2 = this.fileNameLists3.map((item) => {
        return item.name;
      });

      param.fileIds = arr1 || [];
      param.outgoingFileIds = arr2 || [];
      this.$API.wtl_unloadSure(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        this.isShowDialog2 = false;
        this.getData();
      });
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn2() {
      this.isShowDialog2 = false;
    },

    /***
     * ====== 弹窗组件方法 ======
     */

    // 跳转运单详情
    goYdDetails(row) {
      this.$router.push({
        path: "/WaybillManage/WaybillDetails",
        query: {
          waybillSplitId: row.waybillSplitId,
          waybillNumber: row.waybillNumber,
        },
      });
    },
    // 获取货物信息
    getHuoWu() {},

    // 时间组件 选择时间后触发
    queryBtn_time(s, e) {
      this.startTime_a = s || "";
      this.endTime_a = e || "";
    },
    // 时间组件 选择类型后触发
    timestatus(type, s, e) {
      this.timeType = type || "0";
      this.startTime_a = s || "";
      this.endTime_a = e || "";
    },

    // 提交新建客服跟踪
    confirmAdd(formName) {
      this.showDia1 = false;
      this.getData();
    },
    // 关闭客户跟踪弹窗,重置弹窗数据
    closeDia1(e) {
      this.showDia1 = e || false;
      this.documentNumbers = ""; //如果不重置这个,第二次点开同样的数据组件不会监听到变化默认是空的
    },
    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
    rowclick2(row, event, column) {
      this.$refs.memberTable.toggleRowSelection(row);
    },

    getData() {
      let startTaskCreateTime = ""; //业务时间 开始
      let endTaskCreateTime = ""; //业务时间 结束

      let startCreateTime = ""; //创建时间 开始
      let endCreateTime = ""; //创建时间 结束
      if (this.timeType == 1) {
        // 1==创建时间
        startCreateTime = this.startTime_a
          ? this.startTime_a + " 00:00:00"
          : "";
        endCreateTime = this.endTime_a ? this.endTime_a + " 23:59:59" : "";
      } else {
        //业务时间
        startTaskCreateTime = this.startTime_a
          ? this.startTime_a + " 00:00:00"
          : "";
        endTaskCreateTime = this.endTime_a ? this.endTime_a + " 23:59:59" : "";
      }
      let param = {
        carrierId: this.queryData.carrierId,
        customerName: this.queryData.customerName,
        customerOrderNumber: this.queryData.customerOrderNumber,
        endCreateTime: endCreateTime,
        endTaskCreateTime: endTaskCreateTime,
        fieldName: this.queryData.fieldName,
        fieldVal: this.queryData.fieldVal,
        number: this.queryData.number,
        startCreateTime: startCreateTime,
        startTaskCreateTime: startTaskCreateTime,
        taskEndAllAddress: this.queryData.taskEndAllAddress,
        taskStartAllAddress: this.queryData.taskStartAllAddress,
        taskStatus: this.queryData.taskStatus,
        transportPlan: this.queryData.transportPlan,
        transportType: this.queryData.transportType,
        waybillNumber: this.queryData.waybillNumber,

        pageStart: this.pageStart,
        pageTotal: this.pageTotal,
      };
      this.$API.wtl_getTaskList(param).then((res) => {
        if (res.data.status === "success") {
          this.className = res.data.result.className || "";
          this.tableData = res.data.result.data || [];
          this.pageCount = res.data.result.pageCount || 0;
          this.fetTableHeight();
        } else {
          this.$message.error(`${res.data.message}---综合查询列表`);
        }
      });
    },

    queryBtn_ok() {
      //  查询按钮
      this.pageStart = 1;

      this.getData();
    },

    clerBtns() {
      //  重置按钮
      this.queryData = {
        carrierId: "",
        customerName: "",
        customerOrderNumber: "",
        endCreateTime: "",
        endTaskCreateTime: "",
        fieldName: "",
        fieldVal: "",
        number: "",
        startCreateTime: "",
        startTaskCreateTime: "",
        taskEndAllAddress: "",
        taskStartAllAddress: "",
        taskStatus: "",
        transportType: "",
        transportPlan: "",
        waybillNumber: "",
      };
      this.pageStart = 1;
    },

    moreParam() {
      this.isHaseMore = !this.isHaseMore;
      if (this.isHaseMore) {
        this.MoreConditions = "收起条件";
      } else {
        this.MoreConditions = "更多条件";
      }

      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    handleSizeChange(val) {
      //  分页
      this.pageTotal = val;
      this.getData();
    },
    handleCurrentChange(val) {
      //  分页
      this.pageStart = val;
      this.getData();
    },

    AddPackage() {
      //  添加包裹
      this.$router.push({
        path: "/BusinessManagement/addPacks",
      });
    },

    handleSelectionChange(e) {
      // 表格选择事件
      this.selectTableData = e;
    },
    ModifyPackage() {
      //  修改包裹
      if (this.selectTableData.length === 1) {
        this.$router.push({
          path: "/BusinessManagement/addPacks",
          query: {
            packageId: this.selectTableData[0].packageId,
          },
        });
      } else {
        this.$message.error("请选一个需要修改的包裹");
      }
    },

    PackageDetails() {
      //  包裹详情
      if (this.selectTableData.length > 0) {
        this.$router.push({
          path: "/BusinessManagement/packsDetails",
          query: {
            packageId: this.selectTableData[0].packageId,
            courierNumber: this.selectTableData[0].courierNumber,
          },
        });
      } else {
        this.$router.push({
          path: "/BusinessManagement/packsDetails",
        });
      }
    },
    dabaoDetails() {
      //  包裹详情
      if (this.selectTableData.length === 1) {
        if (
          this.selectTableData[0].packageStatus ==
            "chu_ku_zai_tu:package_status" ||
          this.selectTableData[0].packageStatus ==
            "ke_hu_qian_shou:package_status" ||
          this.selectTableData[0].packageStatus ==
            "chu_ku_zhong:package_status" ||
          this.selectTableData[0].packageStatus ==
            "da_bao_wan_cheng:package_status"
        ) {
          this.$router.push({
            path: "/BusinessManagement/dabaoDetails",
            query: {
              packageId: this.selectTableData[0].packageId,
            },
          });
        } else {
          this.$message.error("包裹未打包完成");
        }
      } else {
        this.$message.error("请选择一个包裹");
      }
    },

    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.mathToFixed(
                    this.$TOOLS.add(prev, curr),
                    2
                  );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      return sums;
    },

    /***
     * ==============设置表格动态高度==============
     */
    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0;
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      let queryHeigth = 40 + 10; //10==margin-top: 10  查询框高度
      let btnListHeight = this.$refs.btnList.offsetHeight; // 按钮列表高度
      if (this.isHaseMore) {
        queryHeigth = this.$refs.queryForm.offsetHeight + 10; //查询框
      }
      let pagsHeigth = 40 + 20; //分页组件高度 20是上下margin
      var otherHeight = queryHeigth + btnListHeight + pagsHeigth + 60; //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || ""; //

      this.$nextTick(() => {
        this.tableHeigth = tabHeight;
        this.$refs.mytable.doLayout();
      });
    },

    /****
     *  ===================下面页面公共方法 start ===================
     *
     */

    //顶部跟多按钮的操作
    topCommandBtns(a) {
      if (a === "bgsz") {
        // 设置模板按钮
        // this.myModel();
        this.$TOOLS.myModel(this);
      }
      if (a === "dyyd") {
        // 打印运单
      }
      if (a === "dybq") {
        // 打印标签
      }
      if (a === "dr") {
        // 导入
      }
      if (a === "dc") {
        // 导出
        this.exportBtn();
      }
    },
    // 点击导出 (页面标识,表头,列表标识,数据源,表名)
    exportBtn() {
      this.$COMAPI.exportBtn({
        pageGroupName: this.pageGroupName, //页面标识
        myTableHeard: this.myTableHeard, //表头数组
        className: this.className, //列表标识
        tableData: this.tableData, //数据源
        sheetName: "表名(暂无效)", //表名
      });
    },
    //点击更多操作下的按钮
    handleCommandBtns(type, val) {
      // a==详情
      if (type === "a") {
        this.$router.push("/WaybillManage/WaybillDetails");
      }
      // d==删除
      if (type === "d") {
        this.delBtns(val);
      }
    },

    //    -------------  设置列表表头方法  ------------

    getGroupFindFieldSort() {
      //  获取自定义的排序,没有就用默认的
      this.$API
        .getGroupFindFieldSort({
          groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        })
        .then((res) => {
          let arr = res.data.result || [];
          if (arr.length > 0) {
            if (arr[0].sortObject) {
              this.myTableHeard = JSON.parse(arr[0].sortObject);
              this.sortName = arr[0].sortName;
            }
          } else {
            this.myTableHeard = this.tabelHeadeTitle;
          }
          let totalArr = [];
          //提取需要合计的字段
          for (var i = 0; i < this.myTableHeard.length; i++) {
            if (this.myTableHeard[i].isTotal) {
              totalArr.push(this.myTableHeard[i].field);
            }
          }
          this.totalArr = totalArr;
        });
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
    },

    // ==========排序表头的组件方法==========
    //   取消按钮(表格设置)
    cancelSortHeard() {
      this.show_sortTableHeard = false;
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
    },
    // 排序==>确认按钮(表格设置)
    confirmOk(e) {
      this.tabelHeadeTitle = e;
      this.myTableHeard = this.tabelHeadeTitle;
      let sortObject = this.myTableHeard;
      let param = {
        groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        sortName: this.sortName, //综合查询接口路径
        sortObject: JSON.stringify(sortObject),
      };
      this.$API.pushFindFieldSort(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        //获取默认表头
        this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName);
      });
      this.show_sortTableHeard = false; //关闭弹窗
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      this.show_sortTableHeard = false;
    },
    // 点击某一项(表格设置)
    checktab(idx, e) {
      let that = this;
      that.tabelHeadeTitle[idx].isShow = e;
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
      if (selectLength == that.tabelHeadeTitle.length) {
        that.allCheck = true;
      } else {
        that.allCheck = false;
      }
    },
    //全选(表格设置)
    checkAll(e) {
      let that = this;
      this.allCheck = e;
      for (var j = 0; j < this.tabelHeadeTitle.length; j++) {
        this.tabelHeadeTitle[j].isShow = e;
      }
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
    },
    //关闭弹窗(表格设置)
    closeDias(e) {
      this.show_sortTableHeard = e;
    },

    /****
     *  ===================上面页面公共方法 end ===================
     *
     */

    handleCloseDia3() {
      this.isShowDialog3 = false;
    },
    //  弹窗确认保存事件
    diaConfirmBtn3() {
      this.isShowDialog3 = false;
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn3() {
      this.isShowDialog3 = false;
    },
  },
};
</script>
<style scoped lang="less">
.tableBox {
  height: calc(100% - 260px);
}

.colorStyle {
  color: #f00;
}

.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}

.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }

  .timeBox {
    border: 1px solid #d7d7d7;
  }
}

.headerboxs {
  width: 100%;
  padding: 5px 0;
  display: flex;
  align-items: center;
}

.iconInput {
  display: flex;
  align-items: center;
}
.mainCOlorBtns {
  background-color: #f0a261;
  color: #fff;
  border: none;
}
.mainCOlorBtns :hover {
  color: #fff;
}
</style>
